import React from 'react';
type CTAButtonProps = {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  size?: 'default' | 'large';
  className?: string;
  onClick?: () => void;
  scrollTo?: string;
};
export function CTAButton({
  children,
  variant = 'primary',
  size = 'default',
  className = '',
  onClick,
  scrollTo
}: CTAButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-semibold rounded-lg transition-all duration-200 focus:outline-none focus:ring-4 focus:ring-blue-500/30';
  const variants = {
    primary: 'bg-[#0866FF] text-white hover:bg-[#0756d6] shadow-lg shadow-blue-500/25 hover:shadow-xl hover:shadow-blue-500/30 hover:-translate-y-0.5',
    secondary: 'bg-white text-[#0866FF] border-2 border-[#0866FF] hover:bg-blue-50'
  };
  const sizes = {
    default: 'px-6 py-3 text-base',
    large: 'px-8 py-4 text-lg'
  };
  const handleClick = () => {
    if (scrollTo) {
      const element = document.getElementById(scrollTo);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
    if (onClick) {
      onClick();
    }
  };
  return <button onClick={handleClick} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} data-id="element-174">
      {children}
    </button>;
}